<template>
  <div class="home">
    <Login></Login>
    <globalfoot></globalfoot>
  </div>
</template>

<script>
// @ is an alias to /src
import Login from "@/components/Login";
import globalfoot from "@/components/Global-Foot";

export default {
  data() {
    return {};
  },
  methods: {},
  created() {},

  mounted() {},
  components: {
    Login,
    globalfoot
  }
};
</script>
<style>
.inner-container {
  width: 1190px;
  height: 800px;
  background: #fff;
}
.container {
  height: 800px;
  width: 100%;
  background: #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home {
  display: flex;
  flex-direction: column;
}
</style>